module.exports = __webpack_public_path__ + "static/1-0c79ae01bc517dc303e3dbe1454e5896.png";